import { defineComponent as _defineComponent } from 'vue'
import { VRow } from 'ah-common-lib/src/common/components';
import { VCol } from 'ah-common-lib/src/common/components';
import SpotLimitsEditor from './SpotLimitsEditor.vue';
import ForwardAndOptionLimitsEditor from './ForwardAndOptionLimitsEditor.vue';
import VariationMarginEditor from './VariationMarginEditor.vue';
import { computed, ref, PropType } from 'vue';
import { ClientRiskLimitsProfile } from 'ah-api-gateways';
import { BModal } from 'bootstrap-vue';
import { VButton } from 'ah-common-lib/src/common/components';
import { formatCurrencyValue } from 'ah-common-lib/src/helpers/currency';
import { useRequestManager } from 'ah-common-lib/src/requestManager/useRequestManager';
import { useAhTradesState } from '../../..';
import { useToast } from 'ah-common-lib/src/toast';
import { combineLatest } from 'rxjs';


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateCreditFacilityRequestModal',
  props: {
  clientId: {
    type: String,
    required: true,
  },
  limitsProfileData: {
    type: Object as PropType<ClientRiskLimitsProfile>,
    required: true,
  },
  variationMarginPercentage: {
    type: Number,
    required: true,
  },
},
  setup(__props) {

const props = __props;



const requestManager = useRequestManager().manager;

const tradeState = useAhTradesState();

const toast = useToast();

const isCreditFacilityModalShown = ref<boolean>(false);

const isCreditFacilityReviewAndConfirmModalShown = ref<boolean>(false);

const isSpotLimitsFormInvalid = ref<boolean>(false);

const isForwardAndOptionLimitsFormInvalid = ref<boolean>(false);

const isAnyFormInvalid = computed(() => isSpotLimitsFormInvalid.value || isForwardAndOptionLimitsFormInvalid.value);

const currency = computed(() => props.limitsProfileData.currency);

const parsedVariationMarginPercentage = computed(() =>
  (creditFacilityValues.value.variationMarginPercentage * 100).toFixed(2)
);

const creditFacilityValues = ref({
  spotLimitsAmount: props.limitsProfileData.notionalLimitSpots,
  forwardAndOptionsLimitsAmount: props.limitsProfileData.notionalLimitForwardsOptions,
  variationMarginPercentage: props.variationMarginPercentage,
});

function showCreditFacilityModal() {
  isCreditFacilityModalShown.value = true;
}

function showCreditFacilityReviewAndConfirmModal() {
  isCreditFacilityReviewAndConfirmModalShown.value = true;
}

function cancel() {
  creditFacilityValues.value = {
    spotLimitsAmount: props.limitsProfileData.notionalLimitSpots,
    forwardAndOptionsLimitsAmount: props.limitsProfileData.notionalLimitForwardsOptions,
    variationMarginPercentage: props.variationMarginPercentage,
  };

  isCreditFacilityModalShown.value = false;
  isCreditFacilityReviewAndConfirmModalShown.value = false;
}

function onConfirmCreditFacility() {
  const payload = {
    forwardLimit: creditFacilityValues.value.forwardAndOptionsLimitsAmount,
    spotLimit: creditFacilityValues.value.spotLimitsAmount,
    variationMarginPercentage: creditFacilityValues.value.variationMarginPercentage,
  };
  requestManager
    .currentOrNew(
      'createCreditFacilityRequest',
      combineLatest([
        tradeState.services.credit.createCreditFacilityRequest(props.clientId, payload),
        tradeState.services.limits.notifyUsLimit(),
      ])
    )
    .subscribe(() => {
      isCreditFacilityReviewAndConfirmModalShown.value = false;
      toast.success(
        'Thank you. Your request has been successfully received, and you will be notified when it has been processed.'
      );
    });
}

return { __sfc: true,props, requestManager, tradeState, toast, isCreditFacilityModalShown, isCreditFacilityReviewAndConfirmModalShown, isSpotLimitsFormInvalid, isForwardAndOptionLimitsFormInvalid, isAnyFormInvalid, currency, parsedVariationMarginPercentage, creditFacilityValues, showCreditFacilityModal, showCreditFacilityReviewAndConfirmModal, cancel, onConfirmCreditFacility, VRow, VCol, SpotLimitsEditor, ForwardAndOptionLimitsEditor, VariationMarginEditor, BModal, VButton, formatCurrencyValue }
}

})